<ng-container *ngIf="productAreas">
    <gl-purchase-v2-city-or-municipality-area
        *ngIf="
            !env.IS_NEW_AFC
                ? env.PURCHASE_FLOW?.USE_PRODUCT_AREA_TYPE?.includes('gl-purchase-v2-city-or-municipality-area')
                : (env.PRODUCT_CATEGORY_AREA_NAME && selectedArea?.code === env.PRODUCT_CATEGORY_AREA_NAME) ||
                  selectedArea?.code === ProductCategoryAreaNameEnum.CITY_MUNI
        "
        [productAreas]="productAreas"
        (nextButtonElement)="handleNextButtonElement($event)"
        (nextStep)="handleNextStep()"></gl-purchase-v2-city-or-municipality-area>
    <gl-purchase-v2-single-or-two-area
        *ngIf="
            !env.IS_NEW_AFC
                ? env.PURCHASE_FLOW?.USE_PRODUCT_AREA_TYPE?.includes('gl-purchase-v2-single-or-two-area')
                : selectedArea?.code === 'area'
        "
        [productAreas]="productAreas"
        [selectedProductAreas]="selectedProductAreas"
        (nextButtonElement)="handleNextButtonElement($event)">
    </gl-purchase-v2-single-or-two-area>
    <gl-purchase-v2-from-a-to-b-area
        *ngIf="
            !env.IS_NEW_AFC
                ? env.PURCHASE_FLOW?.USE_PRODUCT_AREA_TYPE?.includes('purchaseV2-from-a-to-b-area')
                : selectedArea?.code === AreaCode.aToB
        "
        [productAreas]="productAreas"
        [selectedProductAreas]="selectedProductAreas"
        (nextButtonElement)="handleNextButtonElement($event)"
        (errorEvent)="handleErrorEvent($event)"></gl-purchase-v2-from-a-to-b-area>
</ng-container>
